import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'

const defaultStrings = {
  anytime: 'Anytime',
  anywhere: 'Anywhere',
  appBenefits: 'App Features',
  getFastEasyMobileAccessWithTheHoxtonMixApp:
    'Download the Hoxton Mix App and take your business mail with you.',
  heroTitle: 'Access your business mail anywhere, anytime',
  heroTitle2: 'Access your mail on the move',
  downloadTheHoxtonMixApp: 'Download the Hoxton Mix app',
  manageYourPhysicalMailWithEase: 'Easily manage your physical and digital mail.',
  onAnyDevice: 'On Any Device',
  p1: '<span class="text-bold text-black">Universal Access</span> — View and manage your business mail from any device, wherever you are.',
  p2: '<span class="text-bold text-black">Mail Forwarding</span> — Forward physical copies to any address or share secure digital copies instantly.',
  p3: '<span class="text-bold text-black">Secure Mailbox Access</span> — Protect your account with two-factor authentication and bank-grade encryption.',
  p4: '<span class="text-bold text-black">Junk Mail Filter</span> — Automatically remove unwanted post with our intelligent filtering system.',
  p5: '<span class="text-bold text-black">Team Sharing</span> — Add team members to your account to automate mail sharing and improve collaboration.',
  p6: '<span class="text-bold text-black">Marketplace</span> — Discover exclusive business offers and tools designed to help your company grow.',
  requiresAnActiveVirtualOfficeSubscription:
    'Available on iOS and Android. Requires an active virtual office subscription.',
  subtitle: 'Manage your virtual office mail securely and conveniently.',
  title: 'Hoxton Mix App – Manage Your Business Mail Anywhere',
}

export const appStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
